export default __webpack_public_path__ + "static/media/AK logo.5bde94ee.svg";